<template>
  <AuthLayout>
    <!-- Forgot password title -->
    <div v-if="emailExist === undefined || !emailExist">
      <h1 class="auth-title">
        {{$t('authentication.resetPassword')}}
      </h1>

      <span class="auth-subtitle">
        {{$t('authentication.infoResetPwd')}}
      </span>
    </div>

    <div v-if="emailExist && resetResponse === 'RESET_PASSWORD_SENT'">
      <span class="auth-subtitle">
        {{$t('authentication.infoEmailExist')}}
      </span>
    </div>

    <div v-if="emailExist && resetResponse === 'FORBIDDEN_BECAUSE_INSTALLATION_NOT_FINISHED'">
      <span class="auth-subtitle">
        {{$t('authentication.echec.clientNoValidate')}}
      </span>
    </div>

    <div v-if="emailExist && resetResponse === 'EMAIL_SYNCHRO'">
      <span class="auth-subtitle">
        {{$t('authentication.echec.userLdap')}}
      </span>
    </div>

    <form name="formResetPassword" class="form-mib">
      <div class="form-placement my-32" v-if="!emailExist">
        <input
          :class="{'mib-not-empty': email}"
          type="text"
          class="inputLabelFloat"
          name="email"
          v-model="email"
          required=""/>
        <label class="labelFloat">
          <span>
            {{$t('authentication.email')}}
          </span>
        </label>
      </div>

      <div class="auth-submit" v-if="!emailExist">
        <button
          class="btn btn-filled-primary"
          type="submit"
          v-on:click.prevent="resetPassword">
          {{$t('authentication.sendEmail')}}
        </button>
      </div>

      <div class="mt-8 auth-secondary-action" v-if="!emailExist">
        <a v-on:click="goToLogin" class="btn-ghost-primary">
          {{$t('authentication.cancel')}}
        </a>
      </div>
    </form>

    <div class="my-32 auth-submit" v-if="emailExist">
      <button
        class="btn btn-filled-primary"
        type="submit"
        v-on:click="goToLogin">
        {{$t('authentication.goToAuth')}}
      </button>
    </div>
  </AuthLayout>
</template>

<script>
    import {resetPasswordByEmail} from "../api/login"
    import AuthLayout from "../components/AuthLayout.vue"

    export default {
        name: 'ResetPassword',
        components: {AuthLayout},
        data() {
            return {
                email: '',
                emailExist: undefined,
                resetResponse: undefined,
            }
        },
        methods: {
            goToLogin(){
                this.$router.push({path: "/login"})
            },
            resetPassword() {
              resetPasswordByEmail(this.email).then(response => {
                this.emailExist = true;
                this.resetResponse = response.data;
              }).catch(error => {
                  this.emailExist = false;
              });
            },
        }
    }

</script>
